// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3dSiW","obliqueLineWrap":"membershipbadge_obliqueLineWrap__GlZyF","obliqueLine":"membershipbadge_obliqueLine__1Ojpe"};